import {
    Button,
    ColourSolid,
    FlexAlign,
    FlexGap,
    FlexJustify,
    Modal,
    ModalType,
    StackVertical,
    useTranslation
} from "@twigsby/frontend-framework";
import {lazy, Suspense, useState} from "react";
import {useNavigate} from "react-router-dom";
import {SendDataProcess} from "../../../SendsAdmin/StandaloneSendForm";

const SendsSendingAnimations= lazy(() => import("../SendsSubmitAnimation"));

interface SendUploadModalType extends ModalType {
    sendData?: SendDataProcess;
    uploadStartedCallback?: any;
    saveSendStartedCallback?: any;
}

const SendMailProcessingModal = (props: SendUploadModalType) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [ startAnimationComplete, setStartAnimationComplete ] = useState<boolean>(false);
    const [ processAnimationComplete, setProcessAnimationComplete ] = useState<boolean>(false);
    const [ endAnimationComplete, setEndAnimationComplete ] = useState<boolean>(false);

    return (
        <Modal title={t("sends.processing.title")} lockOpen={props.lockOpen} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>

            {props.isOpen && (
                <StackVertical gap={FlexGap.Small} extraClass={endAnimationComplete ? 'sends-complete-shifter' : ''}>

                    {!props.sendData?.postingData && (
                        <>
                            <object
                                data={URL.createObjectURL(props.sendData?.form?.file[0])}
                                type="application/pdf"
                                style={{ width: '100%', aspectRatio: '16/9' }}
                            />
                            <div className={'mt-md'}>
                                <h6 className={'m-0'}>{t("sends.processing.labels.recipient")}</h6>
                                <p>{props.sendData?.address}</p>

                                <h6 className={'m-0'}>{t("sends.processing.labels.postage")}</h6>
                                <p>{props.sendData?.postage}</p>
                            </div>
                        </>
                    )}

                    {!props.sendData?.postingData && !props.sendData?.sendComplete && (
                        <Button title={t("sends.processing.actions.confirm")} fullWidth={true} colour={ColourSolid.Primary} onClick={() => props.actionedCallback()} />
                    )}

                    {(props.sendData?.uploadFileActive || props.sendData?.sendDataActive || props.sendData?.sendComplete) && (
                        <StackVertical justify={FlexJustify.Center} gap={FlexGap.Small} align={FlexAlign.Center}>

                            <Suspense>
                                <SendsSendingAnimations
                                    sendData={props.sendData}
                                    startAnimationComplete={startAnimationComplete}
                                    processAnimationComplete={processAnimationComplete}

                                    startCompleteCallback={() => setStartAnimationComplete(true)}
                                    processCompleteCallback={() => setProcessAnimationComplete(true)}
                                    endCompleteCallback={() => setEndAnimationComplete(true)}
                                />
                            </Suspense>

                            <div className={'send-complete-info'}>
                                <h5 className={'text-center mb-xs'}>{t("sends.processing.success.title")}</h5>
                                <p className={'text-center  mb-xl'}>{t("sends.processing.success.description")}</p>

                                <StackVertical gap={FlexGap.ExtraSmall}>
                                    {props.sendData?.mailUuid && (
                                        <Button
                                            title={t("sends.processing.actions.viewItem")}
                                            fullWidth={true}
                                            colour={ColourSolid.Primary}
                                            onClick={() => navigate(`../mail/pending/${props.sendData?.mailUuid}`)}
                                        />
                                    )}

                                    <Button
                                        title={t("sends.processing.actions.close")}
                                        fullWidth={true}
                                        onClick={() => props.closeCallback()}
                                    />
                                </StackVertical>
                            </div>

                        </StackVertical>
                    )}


                </StackVertical>

            )}
        </Modal>
    )
}

export default SendMailProcessingModal
